import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Bell, Search, Lock } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { PrivacyCenter } from '../PrivacyCenter';

export const Header = ({ title }) => {
  const { user, token } = useAuth();
  const [privacyOpen, setPrivacyOpen] = useState(false);

  const initials = user ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase() : '';

  return (
    <header className="h-16 px-6 flex items-center justify-between border-b border-border bg-background/80 backdrop-blur-md sticky top-0 z-30" data-testid="header">
      <h1 className="text-xl font-heading font-semibold tracking-tight">{title}</h1>
      
      <div className="flex items-center gap-4">
        <div className="relative hidden md:block">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input 
            placeholder="Search..." 
            className="pl-9 w-64 bg-muted/50"
            data-testid="global-search"
          />
        </div>

        <Button
          variant="ghost"
          size="icon"
          onClick={() => setPrivacyOpen(true)}
          title="Vie privée"
          data-testid="privacy-center-trigger"
        >
          <Lock className="w-5 h-5" />
        </Button>

        <Button variant="ghost" size="icon" className="relative" data-testid="notifications-btn">
          <Bell className="w-5 h-5" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-primary rounded-full"></span>
        </Button>
        
        <Avatar className="h-9 w-9" data-testid="user-avatar">
          <AvatarImage src={user?.avatar_url} />
          <AvatarFallback className="bg-primary text-primary-foreground text-sm font-medium">
            {initials}
          </AvatarFallback>
        </Avatar>
      </div>

      <PrivacyCenter open={privacyOpen} onOpenChange={setPrivacyOpen} token={token} />
    </header>
  );
};
